import React, { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";
import logo1 from "./logo1.png";
import logo2 from "./logo2.png";
import logo3 from "./logo3.png";

const modules = [
  {
    title: "Learning Process",
    description:
      "The learning process is one of the essential and most important components that is often overlooked. This module does not teach you techniques to learn...",
    tag: "Fundamental",
    sections: 20,
    extra:
      "Here you’ll discover practical frameworks and exercises to make your studying more efficient.",
    image: logo1,
  },
  {
    title: "Intro to Academy",
    description:
      "Your first stop in Hack The Box Academy to become acquainted with the platform, its features, and its learning process.",
    tag: "Fundamental",
    sections: 8,
    extra:
      "This is the perfect starting point to get hands-on and explore the available resources.",
    image: logo2,
  },
  {
    title: "Linux Fundamentals",
    description:
      "This module covers the fundamentals required to work comfortably with the Linux operating system and shell.",
    tag: "Fundamental",
    sections: 30,
    extra:
      "Get confident using commands, file systems, permissions, and shell scripting basics.",
    image: logo3,
  },
];

export default function CyberModules() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const controls = animate(1, 140, {
      duration: 3,
      onUpdate(value) {
        setCount(Math.floor(value));
      },
    });
    return () => controls.stop();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-800 via-blue-900 to-red-950 text-white py-16 px-6">
      {/* === Animated Counter === */}
      <div className="text-center mb-10">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-6xl md:text-7xl font-extrabold text-red-400"
        >
          {count}+
        </motion.h2>
        <h3 className="text-xl md:text-2xl text-gray-200 mt-2">
          cybersecurity modules.
        </h3>
      </div>

      {/* === Filter Buttons === */}
      <div className="flex flex-wrap justify-center gap-4 mb-10">
        <button className="px-6 py-2 rounded-lg font-semibold bg-red-500 text-white hover:bg-red-600 transition">
          General
        </button>
        <button className="px-6 py-2 rounded-lg font-semibold border border-blue-400 text-blue-300 hover:bg-blue-800 transition">
          Offensive
        </button>
        <button className="px-6 py-2 rounded-lg font-semibold border border-blue-400 text-blue-300 hover:bg-blue-800 transition">
          Defensive
        </button>
      </div>

      {/* === Grid of Cards === */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {modules.map((module, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            <motion.div
              className="bg-blue-950/70 border border-red-500 rounded-2xl overflow-hidden hover:shadow-2xl hover:shadow-red-500/30 transition-transform duration-300 flex flex-col h-full"
              whileHover={{ scale: 1.03 }}
            >
              <img
                src={module.image}
                alt={module.title}
                className="w-full h-48 object-contain bg-gradient-to-r from-blue-950 to-red-900"
              />
              <div className="p-5 flex flex-col flex-grow">
                <h5 className="text-xl font-bold text-white mb-2">
                  {module.title}
                </h5>
                <p className="text-gray-300 text-sm flex-grow">
                  {module.description}
                </p>
              </div>
              <div className="flex justify-between items-center text-sm text-gray-300 border-t border-red-700 px-5 py-3">
                <span className="bg-red-600/30 text-red-300 px-3 py-1 rounded-lg text-xs">
                  {module.tag}
                </span>
                <span className="text-blue-300 font-semibold">
                  {module.sections} Sections
                </span>
              </div>

              {/* Hidden Extra Info */}
              <motion.div
                className="p-4 bg-blue-950/60 text-gray-300 text-sm border-t border-blue-700"
                initial={{ opacity: 0, height: 0 }}
                whileHover={{ opacity: 1, height: "auto" }}
                transition={{ duration: 0.4 }}
              >
                {module.extra}
              </motion.div>
            </motion.div>
          </motion.div>
        ))}
      </div>

      {/* === Browse Button === */}
      <div className="flex justify-center mt-10">
        <button className="px-8 py-3 rounded-xl font-bold bg-red-500 text-white hover:bg-blue-700 hover:shadow-lg transition">
          Browse Courses
        </button>
      </div>
    </div>
  );
}
